export default __webpack_public_path__ + "static/media/fuwenben.d8b86d81.png";